import callNativeMobileApp from './callNativeMobileApp';

export function callNativeAppInfo() {
    callNativeMobileApp({
        action: 'request_app_info',
    });
}
